import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "nav-container" }

import { computed } from 'vue';
import { NavLink } from './GamesNavbar.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'GamesNavbar',
  setup(__props) {

const navLinks = computed<NavLink[]>(() => [{ label: 'Attack Armor Value Game', name: 'attack-armor-value-game' }]);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navLinks.value, (link) => {
      return (_openBlock(), _createBlock(_component_RouterLink, {
        key: link.name,
        to: { name: link.name },
        class: "nav-link"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(link.label), 1)
        ]),
        _: 2
      }, 1032, ["to"]))
    }), 128))
  ]))
}
}

})